import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = ({ onBookingClick }) => {
  return (
    <section id="hero" className="relative overflow-hidden min-h-[75vh] flex items-center text-white">
      <div
        className="absolute inset-0 bg-cover bg-bottom"
        style={{
          backgroundImage:
            "url(/images/hero-bg.webp)"
        }}
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="container mx-auto px-6 sm:px-6 relative z-10 py-16 md:py-20">
        <div className="max-w-2xl space-y-6">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs text-sand-100 backdrop-blur">
            <span className="h-2 w-2 rounded-full bg-emerald-300 animate-pulse" />
            <span className="tracking-wide">Запись открыта</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight">
            Качественная помощь
            <br />
            от опытного психолога
          </h1>
          <p className="text-sand-100 text-lg leading-relaxed">
            Помогаю взрослым и детям обрести внутренний баланс, преодолеть кризисы и
            построить устойчивые отношения. Индивидуальный подход и конфиденциальность.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 pt-2">
            <Button
              onClick={() => onBookingClick?.()}
              size="lg"
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-6 rounded-full text-base font-medium shadow-lg hover:shadow-xl transition-all group"
            >
              Записаться на консультацию
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
            </Button>
            <Button
              variant="outline"
              size="lg"
              className="border border-white/60 text-white hover:bg-white hover:text-sand-900 px-8 py-6 rounded-full text-base font-medium"
              onClick={() => document.querySelector('#about').scrollIntoView({ behavior: 'smooth' })}
            >
              Узнать больше
            </Button>
          </div>

          <div className="flex flex-wrap gap-8 pt-6 text-sand-100">
            <div>
              <p className="text-3xl font-serif text-white">30+</p>
              <p className="text-sm text-sand-200">Лет опыта</p>
            </div>
            <div>
              <p className="text-3xl font-serif text-white">3500+</p>
              <p className="text-sm text-sand-200">Консультаций</p>
            </div>
            <div>
              <p className="text-3xl font-serif text-white">1200+</p>
              <p className="text-sm text-sand-200">Клиентов</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
